import React from 'react'
import Link from 'gatsby-link'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap'

import logo from './logo.svg';

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    const { siteTitle } = this.props;

    return (
      <Navbar color="transparent" light expand="lg" className="px-2 px-lg-5 header">
        <NavbarBrand tag={Link} to="/">
          <img src={logo} alt={siteTitle} height="40" />
        </NavbarBrand>
        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            <NavItem>
              <NavLink exact tag={Link} activeClassName="active" to="/">Home</NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} activeClassName="active" to="/referenzen">Referenzen</NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} activeClassName="active" to="/leistungen">Leistungen</NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} activeClassName="active" to="/kontakt">Kontakt</NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js